import {NgModule} from "@angular/core";
import {LoginPageComponent} from "./login-page/login-page.component";
import {LoginPodiumComponent} from "./login-podium/login-podium.component";
import {FedeltaSupportLoginPageComponent} from "./fedelta-support-login-page/fedelta-support-login-page.component";
import {SharedModule} from "../shared/shared.module";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        LoginPageComponent,
        LoginPodiumComponent,
        FedeltaSupportLoginPageComponent
    ],
    exports: [
        LoginPageComponent,
        LoginPodiumComponent,
        FedeltaSupportLoginPageComponent
    ]
})
export class LoginModule {
}
